/* Какая страница приложения каким правом открывается. Ключи — те же, что
   database.PAGES на сервере; сам список прав роли приходит из /api/me.
   Настоящая защита — на сервере (403), здесь лишь прячем пункты меню и
   показываем понятный экран вместо пустой страницы с ошибками. */
export const PATH_PAGES = {
  '/dashboard': 'dashboard',
  '/online': 'online',
  '/writeoffs': 'writeoffs',
  '/kitchen': 'kitchen',
  '/kitchen-screen': 'kitchen',
  '/employees': 'employees',
  '/cash': 'cash',
  '/receipts': 'receipts',
  '/kpi': 'kpi',
  '/crm': 'crm',
  '/purchases': 'purchases',
  '/messages': 'messages',
  '/support': 'support',
};

/* Порядок, в котором ищем «домашнюю» страницу после входа */
const HOME_ORDER = [
  '/dashboard', '/online', '/cash', '/receipts', '/writeoffs', '/kitchen',
  '/purchases', '/crm', '/employees', '/kpi', '/messages', '/support',
];

export const canAccessPage = (user, page) => {
  if (!page) return true;
  if (user?.role === 'admin') return true;
  return Array.isArray(user?.pages) && user.pages.includes(page);
};

export const canAccessPath = (user, path) => canAccessPage(user, PATH_PAGES[path]);

/* Раздел, отключённый платформой (супер-админом), — { reason, ... } или null */
export const moduleBlock = (user, page) => (page && user?.disabled_modules?.[page]) || null;

/* Первая доступная и не отключённая страница; если роли не выдано ни одной —
   профиль, он есть у всех. */
export const homePath = (user) => HOME_ORDER.find(
  path => canAccessPath(user, path) && !moduleBlock(user, PATH_PAGES[path])
) || '/profile';
